import router from '@/router';
import store from '@/store';

export default {
  setSection(state, { sectionId, moduleId }) {
    const oldModuleId = state.currentModuleId;
    const oldSectionId = state.currentSectionId;

    state.currentModuleId = moduleId;
    state.currentSectionId = sectionId;

    if (router.currentRoute.value.name === 'LookAndFeel' && router.currentRoute.value.hash !== `#${moduleId}`) {
      router.replace({ hash: `#${moduleId}` });
    }

    if (sectionId !== oldSectionId || moduleId !== oldModuleId) {
      const mod = store.getters['branding/currentModule'];
      // all previews have splash as the first view.
      // Hence set that as current if nothing is set in focus
      const tabToFocus = mod?.preview?.focus ?? 'splash';
      state.currentTab = tabToFocus;
    }
  },
  changeCurrentTab(state, tab) {
    state.currentTab = tab;
  },
  setCurrentView(state, view) {
    state.currentView = view;
  },
  setMonitorStyles(state, styles) {
    state.monitorStyles = styles;
  },
  setCellphoneStyles(state, styles) {
    state.cellphoneStyles = styles;
  },
  setBrandSettings(state, brandingSettings) {
    state.brandingSettings = {
      ...state.brandingSettings,
      ...brandingSettings
    };
    state.changesMadeInThemeObj = {};
    state.changesMadeInEvent = {};
  },
  clearLocalChanges(state) {
    state.brandingSettings = {};
    state.changesMadeInThemeObj = {};
    state.changesMadeInEvent = {};
  },
  setSwitchingView(state, value) {
    state.switchingViews = value;
  },
  setComplete(state, moduleId) {
    state.completedModules = Array.from(new Set([...state.completedModules, moduleId]));
  },
  resetChangesMadeInThemeObj(state) {
    state.changesMadeInThemeObj = {};
  },
  setChangesMadeInThemeObj(state, payload) {
    state.changesMadeInThemeObj = {
      ...state.changesMadeInThemeObj,
      ...payload
    };
  },
  resetChangesMadeInEvent(state) {
    state.changesMadeInEvent = {};
  },
  setChangesMadeInEvent(state, payload) {
    state.changesMadeInEvent = {
      ...state.changesMadeInEvent,
      ...payload
    };
  },
  setUpdateBrandingLoading(state, isLoading) {
    state.updateBrandingLoading = isLoading;
  },
  setUpdateBrandingError(state, isError) {
    state.updateBrandingError = isError;
  },
  setCurrentModuleInvalid(state, isCurrentModuleInValid) {
    state.isCurrentModuleInValid = isCurrentModuleInValid;
  },
  setBrandingFor(state, forType) {
    state.for = forType;
  },
  setGeneratedThemes(state, { themes, taskId }) {
    state.generatedThemes = themes;
    state.aiThemeGenerationTaskId = taskId;
  },
  clearGeneratedThemes(state) {
    state.generatedThemes = [];
    state.selectedThemeIndex = -1;
  },
  setSelectedThemeIndex(state, index) {
    state.selectedThemeIndex = index;
  },
  setPreviousBrandingState(state, stateObj) {
    state.previousBrandingState = stateObj;
  },
  clearPreviousBrandingState(state) {
    state.previousBrandingState = null;
  },
  setAiThemeGenerationInProgress(state, inProgress) {
    state.aiThemeGenerationInProgress = inProgress;
  },
  setThemeChanges(state, { eventChanges, themeChanges }) {
    state.changesMadeInEvent = eventChanges || {};
    state.changesMadeInThemeObj = themeChanges || {};
  },
  restoreBrandingState(state, { brandingSettings, eventChanges, themeChanges }) {
    if (brandingSettings) {
      state.brandingSettings = {
        ...state.brandingSettings,
        ...brandingSettings
      };
    }
    state.changesMadeInEvent = eventChanges || {};
    state.changesMadeInThemeObj = themeChanges || {};
  },
  setShowAILookAndFeelSurvey(state, show) {
    state.showAILookAndFeelSurvey = show;
  }
};
